import { getNbHitsByIndex } from './get-hits-by-index.js';

function getHitCounts(allSearchResults, indices) {
    var ref, ref1;
    const productsHitCount = getNbHitsByIndex(allSearchResults, (ref = indices.productsIndex) === null || ref === void 0 ? void 0 : ref.name);
    const contentHitCount = getNbHitsByIndex(allSearchResults, (ref1 = indices.contentIndex) === null || ref1 === void 0 ? void 0 : ref1.name);
    return {
        productsHitCount,
        contentHitCount,
        totalHitCount: productsHitCount + contentHitCount
    };
}

export { getHitCounts };
//# sourceMappingURL=get-hit-counts.js.map
